module.exports = __webpack_public_path__ + "img/mm.3f9a7d1e.svg";